import OpenForm from './OpenForm.vue';

export default OpenForm;



// WEBPACK FOOTER //
// ./src/pages/profile/components/openform/index.ts